import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.index-of.js";
// 微信-微信-电影演出票小程序
import Url from '../utils/url';
var goingLogin = false;

// eslint-disable-next-line @myfe/myyc-rules/prefer-optional-chaining
var UA = (window.navigator && window.navigator.userAgent || '').toLowerCase();
var isOpenHarmonyMsc = UA.indexOf('miniprogram msc') > -1;
var isMeituanApp = UA.indexOf('app/meituan') > -1;
var isDianpingApp = UA.indexOf('nova') > -1;
var isMaoyanApp = UA.indexOf('app/imovie') > -1 || UA.indexOf('app/maoyan') > -1;
var sellChannel = 7;
if (isOpenHarmonyMsc) {
  if (isMeituanApp) {
    sellChannel = 2;
  } else if (isDianpingApp) {
    sellChannel = 1;
  } else if (isMaoyanApp) {
    sellChannel = 5;
  }
}
export default {
  appName: 'wxapp_wallet',
  appId: 'wxdbb4c5f1b8ee7da1',
  useKNB: false,
  sellChannel: sellChannel,
  isOpenHarmonyMsc: isOpenHarmonyMsc,
  theme: 'maoyan',
  ajaxUrl: '//wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//m.51ping.com/myshow/ajax',
  preInit: function preInit() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            window.AppData = {
              $wallet: {
                appId: _this.appId || 'wxdbb4c5f1b8ee7da1'
              }
            };
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getUserInfo: function getUserInfo() {
    return {
      token: Url.getQuery('_token') || Url.getHashQuery('_token'),
      openId: Url.getQuery('_openId') || Url.getHashQuery('_openId'),
      userId: Url.getQuery('_userId') || Url.getHashQuery('_userId')
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('_lat') || Url.getHashQuery('_lat') || 31.231706,
      lng: Url.getQuery('_lng') || Url.getHashQuery('_lng') || 121.472644
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('_cityId') || Url.getHashQuery('_cityId'),
      cityName: Url.getQuery('_cityName') || Url.getHashQuery('_cityName')
    };
  },
  login: function login() {
    if (!goingLogin && window.wx) {
      // 防止多次调用
      goingLogin = true;
      setTimeout(function () {
        goingLogin = false;
      }, 3000);
      // end

      window.wx.miniProgram.navigateTo({
        url: "/pages/login/index"
      });
    }
  }
};